import React, { Suspense, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './i18n';
import { PrimeReactProvider } from 'primereact/api';
import Tailwind from 'primereact/passthrough/tailwind';
import { useTranslation } from 'react-i18next';

import RouteConfig from './router/RouteConfig';
import Loader from './components/shared/Loader';

const App = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <PrimeReactProvider value={{ pt: Tailwind, rtl: i18n.language === 'ar' }}>
      <Router>
        <Suspense fallback={<Loader />}>
          <RouteConfig />
        </Suspense>
      </Router>
    </PrimeReactProvider>
  );
};

export default App;
